<template>
    <v-app>
        <v-snackbar
                v-model="snackbar"
                top=true
                color="red"
                timeout=4000
        >
            {{ errorMsg }}
            <v-btn
                    color="white"
                    icon
                    @click="snackbar = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-card width="400px" class="mt-12 mx-auto">
            <v-card-title class="pb-5">
                <h1>Connexion</h1>
            </v-card-title>
            <v-form @submit.prevent="dologin">
                <v-card-text>
                    <v-text-field
                            label="Adresse mail @hyundai.ma"
                            prepend-icon="mdi-account-circle"
                            v-model="username"
                    />
                    <v-text-field
                            label="Mot de Passe"
                            :type="showPassword ? 'text' : 'password'"
                            prepend-icon="mdi-lock"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showPassword = !showPassword"
                            v-model="password"
                    />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-flex justify-center>
                        <v-btn
                                color="success"
                                type="submit"
                        >
                            Se connecter
                        </v-btn>
                    </v-flex>
                </v-card-actions>
                <v-divider class="mt-4 mb-4"></v-divider>
                <v-flex justify-center class="mb-4">
                    <v-btn
                            color="error"
                            text
                            small
                            @click="resetPassword()"
                    >
                        J'ai oublié mon mot de passe ...
                    </v-btn>
                </v-flex>
            </v-form>
        </v-card>
    </v-app>
</template>

<script>

    import { authComputed } from '@/store/helpers.js'
    import NProgress from "nprogress";

    export default {
        name: 'Login',
        data() {
            return {
                showPassword: false,
                snackbar: false,
                errorMsg: '',
                username: '',
                password: ''
            }
        },
        computed: {
            ...authComputed
        },
        methods: {
            resetPassword() {
              if(this.username == ''){
                  this.errorMsg = 'Veuillez saisir un utilisateur (adresse mail)'
                  this.snackbar = true
                  return false;
              }
              let params = {}
              params.action = 'requestResetPassword'
              params.username = this.username
                NProgress.start()


                this.axios
                    .post(this.$store.state.rootUrl+'apiHyundaiConnect.php',params,{timeout: 10000})
                    .then((data) => {
                        if(data.error === true){
                            this.errorMsg = 'Erreur lors de la demande de reset de mot de passe'
                            this.snackbar = true
                            NProgress.done()
                            return false
                        }
                        this.errorMsg = 'Un mail a été envoyé à votre adresse. Veuillez suivre la procédure indiquée dans celui-ci.'
                        this.snackbar = true
                        NProgress.done()
                    })
                    .catch( () => {
                        this.errorMsg = 'Impossible de joindre le serveur'
                        this.snackbar = true
                        NProgress.done()
                    })
            },
            dologin() {
                this.$store
                    .dispatch('login', {
                        username: this.username,
                        password: this.password
                    })
                    .then(() => {
                        if(this.$store.state.user === null){
                            if(this.$store.state.userError != ''){
                                this.errorMsg = this.$store.state.userError
                            }else {
                                this.errorMsg = 'Utilisateur ou mot de passe incorrect !'
                            }
                            this.snackbar = true
                        }else {
                            this.$router.push({name: 'ListeNouvelleDemande'})
                    }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        mounted: function () {
            if(this.loggedIn){
                this.$router.push('/ListeConnect')
            }
        }
    }
</script>
